var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 612,
    height: 612,
    id: "email",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.408,
    d: "M82.35 17.339c-41.335 0-64.571 21.371-64.571 65.036v450.122c0 40.843 20.891 62.228 62.192 62.228h452.024c41.303 0 62.226-20.32 62.226-62.228V82.375c0-42.6-20.923-65.036-63.523-65.036 0 0-448.491-.142-448.348 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 30.655,
    d: "M510.857 445.868V145.054H102.143v300.814h408.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 30.655,
    d: "m105.945 148.886 176.32 178.668c13.069 13.17 36.848 13.014 49.641.12l176.199-177.35M111.999 435.962l135.095-138.106M499.451 434.37 367.999 299.771"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8aa1187be7eb49233d3545724b6619d8.svg";
export { ForwardRef as ReactComponent };